/** @jsx jsx */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';
import { Inline, Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	containerStyle: {
		textDecoration: 'none',
		color: token('color.text'),
		display: 'flex',
		minWidth: '0px',
		height: '24px',
		cursor: 'pointer',
		borderRadius: token('radius.small'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		paddingRight: token('space.050'),
		paddingLeft: token('space.050'),
		paddingTop: token('space.025'),
		paddingBottom: token('space.025'),
		alignItems: 'center',
		gap: token('space.050'),
		font: token('font.body'),
		'&:hover': {
			textDecoration: 'underline',
			color: token('color.text'),
		},
		'&:focus': {
			textDecoration: 'underline',
			color: token('color.text'),
		},
	},
	nameStyle: {
		textOverflow: 'ellipsis',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		flex: 1,
		minWidth: '0px',
	},
});

export const AlikeSmartLink = ({ icon, content }: { icon?: React.ReactNode; content: string }) => {
	return (
		<Inline xcss={styles.containerStyle}>
			{icon}
			<Box xcss={styles.nameStyle}>{content}</Box>
		</Inline>
	);
};
